import { Box, Grid, Typography, Paper } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function Spares() {
  return (
    <Box
      id="spares"
      sx={{
        background: "#F7FAFF",
        py: { xs: 6, md: 10 },
        display: "flex",
        justifyContent: "center",
        fontFamily: "Roboto",
      }}
    >
      <Box sx={{ px: { xs: 2, sm: 4, md: "250px" }, width: "100%" }}>

        {/* HEADING */}
        <Box sx={{ textAlign: "center", mb: 5 }}>
          <Typography
            component="h1"
            sx={{
              fontSize: "32px",
              fontWeight: 700,
              color: "#2d2075",
              letterSpacing: 0.8,
              mb: 1,
            }}
          >
            Spares & Filter Elements
          </Typography>

          <Box
            sx={{
              width: 90,
              height: "3px",
              backgroundColor: "#2d2075",
              mx: "auto",
            }}
          />
        </Box>

        {/* MAIN CARD */}
        <Paper elevation={2} sx={{ p: { xs: 3, md: 5 }, borderRadius: "2px" }}>

          {/* INTRO */}
          <Typography sx={{ fontSize: "20px", color: "#444", mb: 6, lineHeight: 1.5 }}>
            The filter elements housed in filter vessel are meant to remove
            contaminants from industrial processes. These filter elements may
            get blocked or worn out over time, resulting in reducing efficiency.
            For industrial purposes, it requires to change the exhausted filter
            elements to keep up with peak system performance and ensure
            efficiency in operation. Scheduled changing them guarantees to
            maintain consistent filtration performance of filter. They ensure
            uninterrupted operations by replacing clogged or exhausted filter
            media. Multitex provide the spare filter elements on short delivery
            notice as an uninterrupted flow line.
          </Typography>

         {/* TOP TWO COLUMN */}
<Grid container spacing={{ xs: 4, md: 6 }} alignItems="flex-start">
  <Grid item xs={12} md={7}>
    <Typography
      component="h2"
      sx={{ fontSize: "20px", fontWeight: 700, color: "#2d2075", mb: 3 }}
    >
      Why Keeping Spares Matters
    </Typography>

    {[
      {
        title: "Minimizes downtime",
        text: "Immediate replacement prevents process interruption",
      },
      {
        title: "Ensures product quality",
        text: "Consistent filtration efficiency",
      },
      {
        title: "Extends equipment life",
        text: "Protects pumps, valves, and sensitive instruments",
      },
      {
        title: "Cost-effective",
        text: "Reduces emergency procurement expenses",
      },
    ].map((item, i) => (
      <Box key={i} sx={{ display: "flex", mb: 1.4 }}>
        <CheckCircleIcon
          sx={{ color: "#2d2075", fontSize: 18, mr: 1.2, mt: "3px" }}
        />
        <Typography sx={{ fontSize: "20px", lineHeight: 1.5 }}>
          <strong>{item.title}:</strong> {item.text}
        </Typography>
      </Box>
    ))}
  </Grid>



            {/* IMAGE */}
            <Grid item xs={12} md={5}>
              <Box
                sx={{
                  width: "100%",
                  maxWidth: 420,
                  borderRadius: "2px",
                  overflow: "hidden",
                  boxShadow: "0 6px 22px rgba(0,0,0,.12)",
                  ml: "auto",
                }}
              >
                <img
                  src="/Slider 1_1.png"
                  alt="Spare Filter Elements"
                  style={{ width: "100%", height: "auto", objectFit: "contain" }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* FILTER SECTION */}
          <Box sx={{ mt: 8 }}>
            <Typography
              component="h2"
              sx={{ fontSize: "20px", fontWeight: 700, mb: 3, color: "#2d2075" }}
            >
              Filter Candles & Elements
            </Typography>

            <Typography sx={{ mb: 4, fontSize: "20px", color: "#444", lineHeight: 1.5 }}>
             In Industries spanning Oil and Gas, Power, Chemicals, Aviation and various others, the significance of filter and elements particularly advanced solutions like Multitex in maintaining operational efficiency and product quality cannot be overstated. These sectors rely on an array of specialised filters and elements that address unique challenges and Multitex have emerged as a leading choice for optimising these intricate processes. 
            </Typography>

            {/* POINTS */}
            <Grid container spacing={6}>
              {[
                [
                  "Coalescer Pads",
                  "Microwound Candles",
                  <Typography sx={{ fontSize: "20px", lineHeight: 1.5 }}>
                    <strong>Metallic Elements:</strong> Liquid and gas filtration of solid particles
                    and gel particles up to pressure and temperature of 200 bar and 380 degree C respectively.
                  </Typography>,
                  "Paper Filter Elements",
                  <Typography sx={{ fontSize: "20px", lineHeight: 1.5 }}>
                    <strong>Ceramic Filter Tubes:</strong> Gas filtration to remove solid particles and
                    liquid mist, liquid filtration to remove solid particles in high temperature application.
                  </Typography>,
                  <Typography sx={{ fontSize: "20px", lineHeight: 1.5 }}>
                    <strong>Basket Elements:</strong> Liquid filtration for removal of solid particles and debris.
                    Normally being used for pump protection.
                  </Typography>,
                ],
                [
                  "Gas Filter Tubes",
                  <Typography sx={{ fontSize: "20px", lineHeight: 1.5 }}>
                    <strong>Mist Eliminator Candles:</strong> Removal of liquid mist from gases.
                  </Typography>,
                  <Typography sx={{ fontSize: "20px", lineHeight: 1.5 }}>
                    <strong>Demister Pads:</strong> Removal of liquid mist from gases.
                  </Typography>,
                  <Typography sx={{ fontSize: "20px", lineHeight: 1.5 }}>
                    <strong>Coalescer & Separator Elements:</strong> Removal of solid particles,
                    coalescing the water haze emulsion and separate out the same from Hydro-carbon
                    fluid like diesel, kerosene, ATF, etc., & the oil from water.
                  </Typography>,
                  "Custom Built other than the standard product lines, we design & manufacture custom build products exactly meeting the desired specification.",
                ],
              ].map((group, col) => (
                <Grid item xs={12} md={6} key={col}>
                  {group.map((item, i) => (
                    <Box key={i} sx={{ display: "flex", mb: 1 }}>
                      <CheckCircleIcon sx={{ color: "#2d2075", mr: 1, mt: "4px" }} />
                      {typeof item === "string" ? (
                        <Typography sx={{ fontSize: "20px", lineHeight: 1.5 }}>
                          {item}
                        </Typography>
                      ) : (
                        <Box sx={{ fontSize: "20px", lineHeight: 1.5 }}>
                          {item}
                        </Box>
                      )}
                    </Box>
                  ))}
                </Grid>
              ))}
            </Grid>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}
